// extracted by mini-css-extract-plugin
export default {"teamItem":"NewsList_teamItem__IXdxB","artistImg":"NewsList_artistImg__O+WEh","newsDate":"NewsList_newsDate__uMCRD"};